// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1iuu8","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3pJIY"};